module.exports = __webpack_public_path__ + "img/img10.87a70117.png";